interface PauseIconProps {
  className?: string;
  color?: string;
  size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const PauseIcon = ({
  className = "",
  color = "currentColor",
  size = "md",
}: PauseIconProps) => {
  const sizeClasses = {
    base: "w-5.5 h-5.5",
    xs: "w-4 h-4",
    sm: "w-4.75 h-4.75",
    md: "w-5.5 h-5.5",
    lg: "w-6.5 h-6.5",
    xl: "w-7.5 h-7.5",
  };

  return (
    <div className="icon play-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 37 50"
        fill={color}
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        <path d="M4.52539 49.0762C3.23633 49.0762 2.25977 48.7441 1.5957 48.0801C0.951172 47.416 0.628906 46.4395 0.628906 45.1504V4.51562C0.628906 3.22656 0.951172 2.25977 1.5957 1.61523C2.25977 0.951172 3.23633 0.619141 4.52539 0.619141H11.2051C12.4746 0.619141 13.4414 0.931641 14.1055 1.55664C14.7695 2.18164 15.1016 3.16797 15.1016 4.51562V45.1504C15.1016 46.4395 14.7695 47.416 14.1055 48.0801C13.4414 48.7441 12.4746 49.0762 11.2051 49.0762H4.52539ZM25.8242 49.0762C24.5352 49.0762 23.5586 48.7441 22.8945 48.0801C22.2305 47.416 21.8984 46.4395 21.8984 45.1504V4.51562C21.8984 3.22656 22.2305 2.25977 22.8945 1.61523C23.5586 0.951172 24.5352 0.619141 25.8242 0.619141H32.4746C33.7637 0.619141 34.7305 0.931641 35.375 1.55664C36.0391 2.18164 36.3711 3.16797 36.3711 4.51562V45.1504C36.3711 46.4395 36.0391 47.416 35.375 48.0801C34.7305 48.7441 33.7637 49.0762 32.4746 49.0762H25.8242Z" />
      </svg>
    </div>
  );
};
export default PauseIcon;